.infoSection {
    margin-bottom: var(--mantine-spacing-lg);
}

.sectionHeader {
    text-transform: uppercase;
    font-size: var(--mantine-font-size-xs);
    font-weight: 700;
    letter-spacing: 0.05em;
    color: var(--mantine-color-gneis-5);
    margin: 0 0 var(--mantine-spacing-xs);
    line-height: 1;
}

.supplierName {
    font-size: var(--mantine-font-size-sm);
    color: var(--mantine-color-gneis-8);
}
